import {
  IAPIPaginationResponse,
  PaginationModel,
} from "@mindmemobile/mm-shared-global";
import { makeAutoObservable } from "mobx";
import { Subject } from "rxjs";
import { InvoiceDetailPageModel } from "../models/InvoiceDetailPageModel";
import { InvoiceGridModel } from "../models/InvoiceGridModel";
import { IAPIInvoiceGridModel } from "../interfaces/IAPIInvoiceGridModel";

export default class InvoiceStore {
  public gridData: InvoiceGridModel[] = [];
  public pagination: PaginationModel = new PaginationModel({ pageSize: 10 });
  public searchSubject = new Subject<boolean>();
  public searchValue: string = "";
  showFilter: boolean = false;
  public detailPage: InvoiceDetailPageModel | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  toggleFilter(): void {
    this.showFilter = !this.showFilter;
  }

  updateDetailPage(data: InvoiceDetailPageModel): void {
    this.detailPage = new InvoiceDetailPageModel(data);
  }

  updateSearchValue(value: string): void {
    this.searchValue = value;
    this.pagination = new PaginationModel({ pageNumber: 1, pageSize: 10 });
  }

  deserializeGridData(
    data: IAPIInvoiceGridModel[],
    pagination: IAPIPaginationResponse,
    excludePagination: boolean = false
  ): void {
    const mappedData = data.map((item) =>
      InvoiceGridModel.deserializeAPIModel(item)
    );
    this.gridData = mappedData;
    if (!excludePagination) {
      this.pagination = PaginationModel.deserialize(pagination);
    }
  }

  updatePagination(data: PaginationModel): void {
    this.pagination = new PaginationModel(data);
  }
}
